import { ReactNode } from "react";
import styles from "./DataNotice.module.scss";

interface IDataNoticeProps {
  children: ReactNode;
}

export const DataNotice = ({ children }: IDataNoticeProps) => (
  <div className={styles.root}>
    <span className={styles.icon}>📅</span>
    <span>{children}</span>
  </div>
);
